// Display helpers (prototype G's fmt/ago/dur/clock), en-IN.
const MIN = 60e3;
const HR = 3600e3;

export const fmt = (n: number) => Number(n).toLocaleString("en-IN");

export function ago(t: number | null | undefined, now = Date.now()): string {
  if (!t) return "—";
  const d = (now - t) / 1e3;
  if (d < 10) return "just now";
  if (d < 60) return `${Math.floor(d)}s ago`;
  if (d < 3600) return `${Math.floor(d / 60)}m ago`;
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return `${Math.floor(d / 86400)}d ago`;
}

export function dur(ms: number): string {
  if (ms <= 0) return "0m";
  const h = Math.floor(ms / HR);
  const m = Math.floor((ms % HR) / MIN);
  const s = Math.floor((ms % MIN) / 1e3);
  return h ? `${h}h ${String(m).padStart(2, "0")}m` : `${m}m ${String(s).padStart(2, "0")}s`;
}

export const clock = (t: number) =>
  new Date(t).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false });

export const dayClock = (t: number) =>
  new Date(t).toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

export const dayLabel = (t: number) =>
  new Date(t).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });

export function whenLabel(t: number, now = Date.now()): string {
  const d = new Date(t);
  const n = new Date(now);
  const tm = new Date(n);
  tm.setDate(n.getDate() + 1);
  const day =
    d.toDateString() === n.toDateString()
      ? " today"
      : d.toDateString() === tm.toDateString()
        ? " tomorrow"
        : ` on ${d.toLocaleDateString("en-IN", { day: "numeric", month: "short" })}`;
  return clock(t) + day;
}

export const initials = (n: string) =>
  n
    .split(/\s+/)
    .filter(Boolean)
    .map((x) => x[0])
    .join("")
    .slice(0, 2)
    .toUpperCase() || "?";

export function hue(n: string): number {
  let h = 0;
  for (const ch of n) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return h;
}

/** "919812345678" → "+91 98123 45678". Anything else is shown with a leading +. */
export function formatPhone(p: string | null | undefined): string {
  if (!p) return "No valid number";
  if (/^91\d{10}$/.test(p)) return `+91 ${p.slice(2, 7)} ${p.slice(7)}`;
  return `+${p}`;
}
